import {Selector, State} from "@ngxs/store";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {LoginService} from "@sharedAl/services/login.service";

interface AutoLiquidationStateModel {
  loadingStatus: LoadingStatus;
  negotiation: NegotiationModel;
}

export enum LoadingStatus {
  NOT_STARTED = 'NOT_STARTED',
  STARTED = 'STARTED',
  FINISHED = 'FINISHED',
  CORRUPTED = 'CORRUPTED',
}

interface NegotiationModel {
  status: NegotiationStatus,
  step: Number
}

export enum NegotiationStatus {
  NOT_STARTED = 'NOT_STARTED',
  OFFERED = 'OFFERED',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED'
}

const defaultState: AutoLiquidationStateModel = {
  loadingStatus: LoadingStatus.NOT_STARTED,
  negotiation: {
    status: NegotiationStatus.NOT_STARTED,
    step: 0
  }
};

@State<AutoLiquidationStateModel>({
  name: 'autoLiquidationState',
  defaults: JSON.parse(JSON.stringify(defaultState)) as AutoLiquidationStateModel,
})
@Injectable()
export class AutoLiquidationAccountState {

  constructor(private http: HttpClient, private loginService: LoginService) {
  }

  @Selector()
  static autoLiquidationState(state: AutoLiquidationStateModel): AutoLiquidationStateModel {
    return state;
  }
}
